import "./scss/frontend.scss";
import "./js/navigation";
import "./js/blog";
import "./js/faqs";
import "./js/fmp-faqs";
import "./js/team";
import "./js/custom";
import "./js/ordered-list";
import "./js/post-list";
import "./js/resume";
import "./js/reviews-slider";
import "./js/reverse-recruting";
import "./js/career-coaching";
import "./js/checkout";
import "./js/congratulations";
import "./js/chat-form";
